import React from 'react';
import { ArrowPathIcon, SparklesIcon } from '@heroicons/react/24/outline';
import Modal from '../../../../../components/ui/Modal';
import { TRANSCRIPT_PROVIDERS } from '../../../../../constants/transcriptProviders';
import { TRANSCRIPTION_LANGUAGES } from '../../../../../constants/transcriptionLanguages';

const selectClass = 'w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50';

export default function RegenerateTranscriptModal({ generation }) {
  const { isReplaceOpen, closeReplace, confirmReplace, isStarting, provider, setProvider, language, setLanguage } = generation;

  return (
    <Modal isOpen={isReplaceOpen} onClose={closeReplace} title="Regenerate transcript?" size="sm">
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mb-4 text-sm text-yellow-800 font-medium">
        This cannot be undone.
      </div>
      <p className="text-gray-700 mb-4">
        The existing transcript is <strong>permanently deleted</strong> and a new one starts generating right away.
      </p>

      <label htmlFor="regenerate-provider-select" className="block text-sm font-medium text-gray-700 mb-2">Provider</label>
      <select
        id="regenerate-provider-select"
        value={provider}
        onChange={(e) => setProvider(e.target.value)}
        disabled={isStarting}
        className={selectClass}
      >
        {TRANSCRIPT_PROVIDERS.map((p) => <option key={p.value} value={p.value}>{p.label}</option>)}
      </select>
      <p className="text-xs text-gray-500 mt-1">{TRANSCRIPT_PROVIDERS.find((p) => p.value === provider)?.description}</p>

      <label htmlFor="regenerate-language-select" className="block text-sm font-medium text-gray-700 mt-4 mb-2">Transcription language</label>
      <select
        id="regenerate-language-select"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        disabled={isStarting}
        className={selectClass}
      >
        {TRANSCRIPTION_LANGUAGES.map((l) => <option key={l.code} value={l.code}>{l.name}</option>)}
      </select>

      <div className="flex gap-3 mt-6">
        <button
          type="button"
          onClick={closeReplace}
          disabled={isStarting}
          className="flex-1 px-4 py-2 text-gray-700 bg-gray-100 border border-gray-300 rounded-lg hover:bg-gray-200 disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={confirmReplace}
          disabled={isStarting}
          className="flex-1 px-4 py-2 text-white bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50 inline-flex items-center justify-center gap-2"
        >
          {isStarting ? <ArrowPathIcon className="h-5 w-5 animate-spin" /> : <SparklesIcon className="h-5 w-5" />}
          {isStarting ? 'Processing...' : 'Delete & Generate'}
        </button>
      </div>
    </Modal>
  );
}
